import { Box, Stack, Text, Title } from '@mantine/core';
import { Navigate, useParams } from 'react-router-dom';

import { AddScriptsForm } from '../components/AddScripts/AddScriptsForm';
import { ContentBackLink } from '../components/ContentBackLink';
import { ContentExitProvider } from '../components/ContentExitContext';
import { useContentPages } from '../hooks/useContentPages';

import { ListLoader } from '@/components';
import { Platform } from '@/features/pages';
import { useDepartmentStore } from '@/stores/department';

const isPlatform = (value: string): value is Platform =>
  value === 'instagram' || value === 'telegram';

export const AddScriptsPage = () => {
  const { platform, pageId } = useParams<{ platform: string; pageId: string }>();
  const department = useDepartmentStore((state) => state.selected);
  const { pages, isLoading } = useContentPages(department);

  if (!pageId || !platform || !isPlatform(platform)) {
    return <Navigate to="/content" replace />;
  }

  const page = pages.find((item) => item.pageId === pageId && item.platform === platform);

  if (isLoading) {
    return <ListLoader />;
  }

  if (!page) {
    return <Navigate to="/content" replace />;
  }

  return (
    <ContentExitProvider>
      <Box>
        <ContentBackLink />

        <Stack gap={4} mb="xl">
          <Title order={2}>Add scripts — {page.name}</Title>
          <Text size="sm" c="dimmed">
            {platform === 'instagram' ? 'Instagram' : 'Telegram'} · Регион:{' '}
            {department.toUpperCase()} · Тип: Text
          </Text>
        </Stack>

        <AddScriptsForm department={department} pageId={pageId} />
      </Box>
    </ContentExitProvider>
  );
};
